<template>
    <div class="content-container">
        <div class="table-wrapper">
            <div class="tip-header">
                <div class="tip-box">
                    全部成員：<span class="num">{{user_count}}</span>人(還可以加入<span class="num">{{surplus_user_count}}</span>人)
                </div>
                <div class="tip-btn" v-if="this.userInfo.uid == this.create_user_id">
                    <a-button type="primary" @click="addNewTeamMember">邀請新團隊成員</a-button>
                    <a-button type="danger" @click="delMember">移除成員</a-button>
                </div>
            </div>
            <a-table
                    :data-source="teamUserList"
                    :loading="loading"
                    rowKey="id"
                    :pagination="false"
            >
                <a-table-column
                   :key="'input'"
                   title=""
                   :align="'center'"
                   v-if="this.userInfo.uid == this.create_user_id"
                 >
                    <template slot-scope="text, record">
                        <a-input 
                            type="checkbox" style="width: 25%;" @click="handleDelete(record, $event)"
                            v-if="record.user_id != create_user_id"
                        />
                    </template>
                 </a-table-column>
                <!-- 名稱 -->
                <a-table-column
                        key="user_team_name"
                        :title="$t('table.teamUser.thead.name')"
                        data-index="user_team_name"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <div class="team-name">{{ record.user_team_name}}<span v-if="record.user_id == create_user_id">{{$t('table.teamUser.thead.admin')}}</span></div>
                    </template>
                </a-table-column>
                <!-- 頭像 -->
                <a-table-column
                        key="avatar"
                        :title="$t('table.teamUser.thead.avatar')"
                        data-index="avatar"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <img class="avatar-img" :src="record.avatar?record.avatar:defaultAvatar"/>
                    </template>
                </a-table-column>
                <!-- 聯繫電話 -->
                <a-table-column
                        key="phone"
                        :title="$t('table.teamUser.thead.phone')"
                        data-index="phone"
                        align="center"
                />
                <!-- 加入時間 -->
                <a-table-column
                        key="create_time"
                        :title="$t('table.teamUser.thead.createTime')"
                        data-index="create_time"
                        align="center"
                />
                <!-- 職位 -->
                <a-table-column
                        key="position"
                        :title="$t('table.teamUser.thead.position')"
                        data-index="position"
                        align="center"
                >
                    <template slot-scope="text, record">
                        {{ record.position ? record.position : "--" }}
                    </template>
                </a-table-column>
                <!-- line -->
                <a-table-column
                        key="line_account"
                        :title="$t('table.teamUser.thead.line')"
                        data-index="line_account"
                        align="center"
                >
                    <template slot-scope="text, record">
                        {{ record.line_account ? record.line_account : "--" }}
                    </template>
                </a-table-column>
                <!-- email -->
                <a-table-column
                        key="email"
                        :title="$t('table.teamUser.thead.email')"
                        data-index="email"
                        align="center"
                >
                    <template slot-scope="text, record">
                        {{ record.email ? record.email : "--" }}
                    </template>
                </a-table-column>
            </a-table>
        </div>
        <a-modal :visible="addMemberVisible" :width="600"
                :title="$t('table.teamUser.thead.addNew')"
                :footer="null"
                @cancel="closeAddMember"
                >
                <div>
                    複製以下網址，分享給新的團隊成員
                </div>
                <br>
                <div class="inputUrl">
                    <input :value="newMemberUrl" readonly style="width: 85%;">
                    
                    <a-button type="primary" @click="copy()">複製</a-button>
                </div>
        </a-modal>

        <a-modal :visible="dleMemberVisible" :width="600"
                :title="$t('table.teamUser.thead.delMember')"
                :footer="null"
                @cancel="closeDelMember"
                >
                <div class="inputUrl">
                    <div class="delInfo">
                     確定要刪除成員嗎？
                    </div>
                    <div class="tip-btn" v-if="this.userInfo.uid == this.create_user_id">
                        <a-button type="primary" @click="delTeamMember">確定</a-button>
                        <a-button type="danger" @click="cancelTeamMember">取消</a-button>
                    </div>
                </div>
        </a-modal>
    </div>
</template>

<script>
    import {getTeamUser, delTeamUser} from "@/api/team";
    import {mapState} from "vuex";
    export default {
        name: "List",
        data(){
            return{
                defaultAvatar: require('@/assets/default_h.jpg'),
                teamUserList:[],
                loading: false,
                team_id: 0,
                create_user_id: 0,
                user_count: 0,
                surplus_user_count: 0,
                addMemberVisible:false,
                dleMemberVisible:false,
                newMemberUrl:"",
                selectedIds: [],
            }
        },
        computed:{
            ...mapState({
                userInfo: (state) => state.user.userInfo,
            }),
        },
        mounted() {
            this.team_id = Number(this.userInfo.team_id)
            this.loadData()
        },
        methods:{
            //獲取團隊成員信息
            loadData(){
                getTeamUser({team_id: this.team_id}).then(res=>{
                    if(res.code == 1){
                        this.teamUserList = res.data.user_list
                        this.create_user_id = res.data.team_info.create_user_id
                        this.user_count = res.data.user_count
                        this.surplus_user_count = res.data.surplus_user_count
                        this.newMemberUrl = `https://qwhouse720.com/qwj/teamInvitation?id=${res.data.team_info.id}`;
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            addNewTeamMember(){
                this.addMemberVisible = true;
                console.log('userInfo', this.newMemberUrl);
            },
            closeAddMember(){
                this.addMemberVisible = false;
            },
            copy(){
                if (navigator.clipboard) {
                navigator.clipboard.writeText(this.newMemberUrl)
                  .then(() => {
                    this.$message.success('複製連結成功!');
                  })
                  .catch((error) => {
                    // 複製失敗時的處理
                    alert("複製連結失敗：" + error.message);
                  });
                 } else {
                alert("瀏覽器不支援剪貼板操作。");
              }
            },
            handleDelete(record, event) {
                if (event.target.checked) {
                    // 如果複選框被勾選，將整個 record 添加到 selectedRecords
                    this.selectedIds.push(record);
                } else {
                    // 如果複選框被取消勾選，將 record 從 selectedRecords 移除
                    const index = this.selectedIds.findIndex(item => item.id === record.id);
                    if (index !== -1) {
                        this.selectedIds.splice(index, 1);
                    }
                }
                console.log('目前的選中記錄:', this.selectedIds);
            },

            delMember(){
                if (this.selectedIds.length > 0) {
                    this.dleMemberVisible = true;
                }else{
                    this.$message.error('請先勾選刪除帳號');
                }
            },
            cancelTeamMember(){
                this.dleMemberVisible = false;
            },
            closeDelMember(){
                this.dleMemberVisible = false;
            },
            delTeamMember() {
                this.loading = true;
                const promises = this.selectedIds.map(info => {
                    const params = {
                        team_user_id: info.user_id,
                        team_id: info.team_id,
                    };
                    return delTeamUser(params);
                });
                Promise.all(promises).then(results => {
                    this.loading = false;
                    // 可以檢查所有結果，看是否都成功，然後顯示相應的消息
                    if (results.every(res => res.code === 1)) {
                        this.$message.success('全部刪除成功');
                        window.location.reload(); // 重新整理頁面
                    } else {
                        this.$message.error('部分刪除失敗');
                    }
                }).catch(error => {
                    this.loa6ding = false;
                    console.error(error);
                    this.$message.error('網絡不給力，請檢查網絡設置');
                    });
                }   
        }
    }
</script>

<style lang="less" scoped>
    .team-name{
        display: flex;
        align-items: center;
        justify-content: center;
        span{
            display: inline-block;
            background-color: #1890ff;
            color: #fff;
            font-size: 12px;
            padding: 6px 12px;
            border-radius: 0 20px 20px 20px;
            margin-left: 4px;
        }
    }
    .avatar-img{
        width: 70px;
        height: 70px;
        border-radius: 50%;
        object-fit: cover;
    }
    .tip-box{
        padding-bottom: 24px;
        .num{
            color: #1890ff;
        }
    }
    .tip-header{
        display: flex;
        justify-content: space-between;
    }
    .tip-btn{
        display: flex;
        gap: 10px;
    }
    .inputUrl{
        justify-content: space-between;
        display: flex;
    }
    .delInfo{
        font-weight: bold;
        font-size: large;
    }
</style>